export const types = {
  SET_STEP_INDEX: 'SET_STEP_INDEX',
  SET_STEP_DATA: 'SET_STEP_DATA',
  CLEAR_STEPS: 'CLEAR_STEPS',
  SET_STEP_RESULT: 'SET_STEP_RESULT',
};
